import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import './home.css'
import Content from '../home_content/Content';
export default function Home() {
  return (
    <>
    <Navbar/>
    <Content/>
    <Footer/>
    </>
  );
}


